import { render } from "./imageOnly.vue?vue&type=template&id=01a984d0&scoped=true"
import script from "./imageOnly.vue?vue&type=script&lang=js"
export * from "./imageOnly.vue?vue&type=script&lang=js"

import "./imageOnly.vue?vue&type=style&index=0&id=01a984d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a984d0"]])

export default __exports__